import { Logo } from "@assets/Logo";
import { cn } from "@shadcn/lib/utils";
import { PropsWithChildren } from "react";

const showImage = false;
export const AuthLayout = (props: PropsWithChildren) => {
	const { children } = props;
	return (
		<div className="bg-background min-h-svh md:flex">
			{/* Left side: Sign-in form */}
			<div
				className={cn("relative items-center justify-center px-6 md:flex", {
					"md:w-1/2 xl:w-1/3": showImage,
					"w-full items-center": !showImage,
				})}
			>
				{/* Logo */}
				<div className="flex pt-6 pb-4 justify-center md:py-0 md:absolute md:top-4 md:left-4">
					<Logo className="h-6 md:w-32" />
				</div>

				{/* Sign-in form container */}
				{children}
			</div>

			{/* Right side: Image */}
			{showImage && (
				<img
					src="https://ui.shadcn.com/placeholder.svg"
					alt="Image"
					width="1800"
					height="1800"
					className="hidden w-1/2 object-right object-cover md:block xl:w-2/3"
				/>
			)}
		</div>
	);
};
